import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import SongPlayer from '../components/SongPlayer';
import toast from 'react-hot-toast';
import Skeleton from 'react-loading-skeleton';

interface Song {
  id: string;
  song_url: string;
  song_cover: string;
  creator: string;
  language: 'english' | 'spanish' | 'french';
  song_lyrics: string;
  translation: string | null;
  song_vocabulary: any;
}

export default function SongPage() {
  const [song, setSong] = useState<Song | null>(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    loadSong();
  }, [id]);

  const loadSong = async () => {
    try {
      const { data, error } = await supabase
        .from('stripeensongs')
        .select('*')
        .eq('id', id)
        .maybeSingle();

      if (error) throw error;
      if (!data) {
        toast.error('Song not found');
        navigate('/songs');
        return;
      }

      setSong(data);
    } catch (error: any) {
      toast.error('Error loading song');
      navigate('/songs');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="px-4 sm:px-6 lg:px-8 bg-gray-100">
        <Skeleton height={400} className="mb-8" />
        <Skeleton count={5} className="mb-4" />
      </div>
    );
  }

  if (!song) {
    return null;
  }

  return <SongPlayer song={song} onClose={() => navigate('/songs')} autoPlay={true} />;
}